import { render, staticRenderFns } from "./CustomHR.vue?vue&type=template&id=6bfc4d72&scoped=true"
import script from "./CustomHR.vue?vue&type=script&lang=js"
export * from "./CustomHR.vue?vue&type=script&lang=js"
import style0 from "./CustomHR.vue?vue&type=style&index=0&id=6bfc4d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc4d72",
  null
  
)

export default component.exports